import { SVGProps } from "react";

export function UserCheckMark(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 14 14"
      width="20px"
      height="20px"
      {...props}
    >
      <g
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="m13.5 8l-4.12 5.5l-2.75-2.06"></path>
        <circle cx="5" cy="2.75" r="2.25"></circle>
        <path d="M3 12.5H.5V11a4.5 4.5 0 0 1 7.68-3.18"></path>
      </g>
    </svg>
  );
}
